export default class extends HTMLElement {
  connectedCallback () {
    if (this.expandButton) {
      this.expandButton.addEventListener('click', () => {
        this.expandButton.classList.add('hidden')

        this.expandButton.previousElementSibling.classList.remove('hidden')
        this.expandButton.previousElementSibling.previousElementSibling.classList.remove('mb-6')
      })
    }
  }

  get expandButton () {
    return this.querySelector('#show-all-button')
  }
}
